// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"748":"6d77eed1","1330":"82d9aafe","2221":"358afba9","2393":"1b873426","2924":"f7f76acf","3749":"ff351404","6138":"1da295d1"}[chunkId] + ".chunk.css";
};